<template>
  <div style="min-height: 150px">
    <div style="padding: 15px 10px;">
      <div style="display: flex;padding: 0 0 20px 0; align-items: flex-end;gap: 20px">
        <el-button v-if="isPart" type="primary" :loading="exportLoading" @click="exportData">
          导出订单明细
          <!-- </el-button><span style="margin-left: 25px;color: red">如果实际结算金额为零时，请代理商先发布完合同信息后，再关注，谢谢！{{ this.specialCloudDesc }}</span> -->
        </el-button>
        <div v-if="isDistribution" style="display: flex; align-items: flex-end">
          <el-button type="primary" :loading="exportVolumeInformationLoading" @click="exportVolumeInformation">
            导出材料信息
          </el-button>
          <div style="display: inline-flex; gap: 20px; margin-left: 20px;font-weight: 400;font-size: 16px">
            <span>预估体积(CBM): <span style="font-weight: 700;margin: 0 5px 0 10px">{{ Number(estimatedVolume).toFixed(2) ?? 'N/A' }}</span>m³</span>
            <span>预计重量: <span style="font-weight: 700;margin: 0 5px 0 10px">{{ Number(estimatedGrossWeight).toFixed(2) ?? 'N/A' }}</span>kg</span>
          </div>
        </div>
      </div>
      <!-- <span style="margin-left: 30px;">是否多地址发货: {{ multiaddress ? '是' : '否' }}</span> -->
      <!-- <el-button type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true" v-if="this.contractType !=='SMB分销下单'">更改地址</el-button> -->
      <el-table :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="50" label="序号" align="left" />
        <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="150" />
        <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
        <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
        <el-table-column prop="counct" label="数量" align="left" width="60">
          <template v-slot="{row}">
            <span v-if="contractType !=='服务订单'">{{ Number(row.counct).toFixed(0) }}</span>
            <span v-else>{{ Number(row.serviceLife) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productUnit" label="单位" align="left" width="100" />
        <el-table-column prop="productPriceSigle" label="单价" align="right" width="100" header-align="left" />
        <el-table-column prop="orderAmount" label="订单金额" align="right" width="120" header-align="left" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="right" width="100" header-align="left" />
        <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101')) ">
          <el-table-column prop="expectedDeliveryDate" label="期望齐套日期" align="left" width="150" />
        </template>
        <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101')) ">
          <el-table-column prop="expectedShippingDate" label="期望发货日期" align="left" width="150" />
        </template>
        <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101'))">
          <el-table-column prop="expectedArrivalDate" label="期望到货日期" align="left" width="150" />
        </template>
        <template v-if="!(departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101')))">
          <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="150" />
        </template>
        <el-table-column
          prop="productConfigInfo"
          label="产品配置描述"
          align="left"
        />
        <template v-if="contractType =='国际分销下单'">
          <el-table-column
            prop="serviceDesc"
            label="服务备注"
            align="left"
          />
        </template>
      </el-table>
    </div>
    <address-box :prop-open.sync="showAddress" @chooseAddress="changeAddress" @ChangeDatas="ChangeDatas" />
  </div>
</template>
<script type="es6">
/**
 * 商务节点 详情产品列表
 */
import addressBox from '@/views/address/index.vue';
import { exportContractExcel, getContractProductVolume, getDictData } from '@/API/international';
import axios, { getReceiptAddressByContractId, updateContractReceiptAddress, getContractProsAndSpecialPros, getReceiptAddressInfoModel, updateMultiaddress } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      address: {},
      exportLoading: false,
      showAddress: false,
      // 是否多地址发货
      formData: { multiaddress: '' },
      warehouseList: [],
      estimatedVolume: 0,
      estimatedGrossWeight: 0,
      exportVolumeInformationLoading: false
    };
  },
  computed: {
    isDistribution () {
      return this.contractType === '国际分销下单';
    }
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    specialProduct: {
      type: Number,
      default: () => { return 0; }
    },
    specialCloudDesc: {
      type: String,
      default: () => { return ''; }
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    },
    multiaddress: {
      type: String,
      default: ''
    },
    multiaddressValue: {
      type: String,
      default: ''
    },
    contractId: {
      type: Number,
      default: 0
    },
    departmentCode: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    },
    orderUnit: {
      type: String,
      default: ''
    },
    soldCountry: {
      type: String,
      default: ''
    },
    isPart: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    multiaddress: {
      immediate: true,
      handler (newVal) {
        this.formData.multiaddress = newVal;
      }
    },
    soldCountry: {
      handler (newVal) {
        if (this.strContractCode && newVal) {
          this.getVolumeInformation();
        }
      },
      deep: true,
      immediate: true
    },
    contractId: {
      immediate: true,
      handler (newVal) {
        this.contractId = newVal;
        if (this.contractId) {
          this.initData();
          this.searchDetail();
        }
      }
    }
  },

  components: {
    addressBox
  },
  created () {
    this.queryWarehouse();
  },
  methods: {
    // 提交多地址
    submitMultiaddress () {
      let newFormat = { multiaddress: '' };
      if (this.formData.multiaddress === '其他') {
        if (!this.multiaddressValue) {
          this.$message.error('请输入特殊发货需求');
          return;
        }
        newFormat.multiaddress = '特殊发货需求--' + this.multiaddressValue;
      } else {
        newFormat.multiaddress = this.formData.multiaddress;
      }
      let params = { ...newFormat, contractId: this.contractId };
      updateMultiaddress(params).then(res => {
        let { status, err } = res.data;
        if (status === '200') {
          this.$message.success(err);
        }
      });
    },
    queryWarehouse () {
      let params = { dictType: 'desc_of_special_requirements' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.warehouseList = data;
        }
      });
    },
    initData () {
      getReceiptAddressByContractId(this.contractId).then((res) => {
      // getReceiptAddressByContractId(this.$route.query.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.address = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    searchDetail () {
      getContractProsAndSpecialPros(this.contractId, this.$route.query.isSon).then((res) => {
      // getContractProsAndSpecialPros(this.$route.query.id, this.$route.query.isSon).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (this.contractType !== '国际分销下单' || !json.data) {
            this.tableData = json.data;
            return;
          }
          if (json.data[0].orderProductId === null && !json.data[0].serviceDesc) {
            this.tableData = json.data.map(item => {
              if (item) {
                if (!item.expectedDeliveryDate) {
                  item.expectedDeliveryDate = '一';
                }
                if (!item.expectedShippingDate) {
                  item.expectedShippingDate = '一';
                }
                if (!item.expectedArrivalDate) {
                  item.expectedArrivalDate = '一';
                }
              }
              return item;
            });
          } else {
            let productList = [];
            let zeroList = [];
            json.data.forEach(item => {
              if (item) {
                if (!item.expectedDeliveryDate) {
                  item.expectedDeliveryDate = '一';
                }
                if (!item.expectedShippingDate) {
                  item.expectedShippingDate = '一';
                }
                if (!item.expectedArrivalDate) {
                  item.expectedArrivalDate = '一';
                }
              }
              if (item.orderProductId) {
                productList.push(item);
                let l1Arr = [];
                let l2Arr = [];
                json.data.forEach(one => {
                  if (Number(one.serviceKeyList) === item.orderProductId && one.orderAmount) {
                    if (one.serviceLevel === 1) {
                      l1Arr.push(one);
                    } else if (one.serviceLevel === 2) {
                      l2Arr.push(one);
                    } else {
                      productList.push(one);
                    }
                  }
                });
                productList = [...productList, ...l1Arr, ...l2Arr];
              } else if (!item.orderAmount) {
                zeroList.push(item);
              }
            });
            const merged = Array.from(
              zeroList.reduce((map, item) => {
                const { productName } = item;
                const existing = map.get(productName);
                if (existing) {
                  existing.counct = Number(existing.counct) + Number(item.counct) + '';
                } else {
                  map.set(productName, { ...item });
                }
                return map;
              }, new Map())
            ).map(([_, value]) => value);

            this.tableData = [...productList, ...merged];
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    exportData () {
      this.exportLoading = true;
      let query = this.$route.query.isSon === true;
      axios.get(('/export/getExportContractDetailInfo?contractNum=' + this.strContractCode + '&isSon=' + query), {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '订单明细列表.xls';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.allNum();
        }
        if (column.label === '订单金额') {
          sums[index] = this.allOrderAmount();
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.allSettlementAmount();
        }
      });
      return sums;
    },
    allNum () {
      let cont = 0;
      if (this.contractType !== '服务订单') {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.counct);
        });
      } else {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.serviceLife);
        });
      }

      // cont = Number(cont).toFixed(2);
      return cont;
    },
    allOrderAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.orderAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    allSettlementAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmountNum);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    changeAddress (val) {
      // 选择其他地址
      updateContractReceiptAddress(val.id, this.$route.params.contractNum).then((res) => {
        this.$message.success('地址修改成功');
        this.address = val;
        this.showAddress = false;
        this.$emit('chooseAddress', val);
        this.$emit('changeAddress');
      }).catch((err) => {
        console.log(err);
      });
    },
    stopProp (e) {
      e.stopPropagation();
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    exportVolumeInformation () {
      this.exportVolumeInformationLoading = true;

      let params = {
        contractNum: this.strContractCode,
        projectName: this.projectName,
        partnerName: this.orderUnit,
        soldCountry: this.soldCountry
      };

      exportContractExcel(params).then((res) => {
        this.exportVolumeInformationLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileReg = /filename=(.+)\.xlsx/;
        const fileName = res.headers['content-disposition'].match(fileReg)[0].replace(/"/, '').split('=')[1];
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportVolumeInformationLoading = false;
      });
    },
    getVolumeInformation () {
      const params = {
        soldCountry: this.soldCountry,
        contractNum: this.strContractCode
      };
      getContractProductVolume(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.estimatedVolume = json.data.estimatedVolume;
          this.estimatedGrossWeight = json.data.estimatedGrossWeight;
        }
      });
    }
  },
  mounted () {
    // this.initData();
    // this.searchDetail();
    if (this.strContractCode && this.soldCountry) {
      this.getVolumeInformation();
    }
  }
};
</script>

<style lang="scss" scoped>
.row-tip{
  display: flex;
  align-items: center;

  .form-wrap{
    width: 500px;
    margin-left: 30px;
    .el-input--mini{
          width: 100px;
          margin-left:10px
    }
  }

  button{
    position: relative;
    top: -10px;
  }
}
</style>
